export const SERVER_AI_URL = import.meta.env.VITE_SERVER_AI_URL;
export const APP_URL = import.meta.env.VITE_APP_URL;
export const WEBSITE_URL = import.meta.env.VITE_WEBSITE_URL;
// Base URL for the datafeed HTTP API. Empty string ("") means same-origin —
// requests go to a relative "/datafeed/..." path (e.g. proxied by the reverse
// proxy on the app host), which keeps it reachable over any hostname the page
// was loaded from (Tailscale/LAN included).
export const DATAFEED_API = import.meta.env.VITE_DATAFEED_API ?? '';

// WebSocket URL for the datafeed (Workbench chart). Precedence:
//   1. explicit VITE_DATAFEED_WS
//   2. derived from an absolute VITE_DATAFEED_API (swap http(s) -> ws(s))
//   3. same-origin fallback: derive from window.location when DATAFEED_API is
//      empty/relative (matches the same-origin "/datafeed" HTTP proxy above)
function deriveDatafeedWs() {
  if (import.meta.env.VITE_DATAFEED_WS) return import.meta.env.VITE_DATAFEED_WS;
  if (/^https?:/i.test(DATAFEED_API)) {
    return `${DATAFEED_API.replace(/^http/, 'ws').replace(/\/+$/, '')}/datafeed/ws`;
  }
  if (typeof window !== 'undefined') {
    const wsProto = window.location.protocol === 'https:' ? 'wss' : 'ws';
    const prefix = DATAFEED_API.replace(/\/+$/, '');
    return `${wsProto}://${window.location.host}${prefix}/datafeed/ws`;
  }
  return undefined;
}
export const DATAFEED_WS = deriveDatafeedWs();
export const COOKIE_DOMAIN = import.meta.env.VITE_COOKIE_DOMAIN;
export const CANNY_BOARD_TOKEN = import.meta.env.VITE_CANNY_BOARD_TOKEN;
export const TURNSTILE_SITE_KEY = import.meta.env.VITE_TURNSTILE_SITE_KEY;